/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_4_HInputs */

const en_privacy_4_h = /** @type {(inputs: Privacy_4_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const id_privacy_4_h = /** @type {(inputs: Privacy_4_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Privacy_4_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_4_h = /** @type {((inputs?: Privacy_4_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_4_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_4_h(inputs)
	return en_privacy_4_h(inputs)
});